import {
   ADD_RECEIVE_INVENTORY,
   UPDATE_RECEIVE_INVENTORY,
   GET_RECEIVE_INVENTORY,
   GET_RECEIVE_INVENTORIES,
   GET_RECEIVE_INVENTORIES_FOR_RO,
   GET_RECEIVE_INVENTORIES_FOR_ITV,
   GET_RECEIVE_INVENTORIES_FOR_RFV,
   GET_RECEIVE_INVENTORIES_FOR_S,
   GET_RECEIVE_INVENTORIES_FOR_R,
   DELETE_RECEIVE_INVENTORY,
   EMPTY_ONE_RECEIVE_INVENTORY,
   GET_LAST_RECEIVE_DAYBOOK,
   GET_RECEIVE_INVENTORY_PREV_AND_NEXT,
   GET_PENDING_RECEIVE_INVENTORY,
   GET_SINGLE_RECEIVE_INVENTORIES,
} from '../types';

const initialState = {
   listForRO: [],
   listForITV: [],
   listForRFV: [],
   listForS: [],
   listForR: [],
   list: [],
   single: null,
   totalCount: 0,
   totalCountForRO: 0,
   totalCountForITV: 0,
   totalCountForRFV: 0,
   totalCountForS: 0,
   totalCountForR: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   paginationForRO: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   paginationForITV: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   paginationForRFV: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   paginationForS: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   paginationForR: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   prevAndNext: null,
   getPendingReceiveInventories: [],
   receiveData: null,
};

const reducer = (state = initialState, { type, payload }) => {
   switch (type) {
      case 'SET_LOADING':
         return { ...state, isLoading: payload };

      case GET_RECEIVE_INVENTORIES:
         return {
            ...state,
            list: payload.data,
            totalCount: payload.totalCount,
            pagination: payload.pagination,
            isLoading: false,
         };

      case GET_RECEIVE_INVENTORIES_FOR_RO:
         return { ...state, listForRO: payload.data, totalCountForRO: payload.totalCount, paginationForRO: payload.pagination, isLoading: false, };

      case GET_RECEIVE_INVENTORIES_FOR_ITV:
         return { ...state, listForITV: payload.data, totalCountForITV: payload.totalCount, paginationForITV: payload.pagination, isLoading: false, };

      case GET_RECEIVE_INVENTORIES_FOR_RFV:
         return { ...state, listForRFV: payload.data, totalCountForRFV: payload.totalCount, paginationForRFV: payload.pagination, isLoading: false, };

      case GET_RECEIVE_INVENTORIES_FOR_S:
         return { ...state, listForS: payload.data, totalCountForS: payload.totalCount, paginationForS: payload.pagination, isLoading: false, };

      case GET_RECEIVE_INVENTORIES_FOR_R:
         return { ...state, listForR: payload.data, totalCountForR: payload.totalCount, paginationForR: payload.pagination, isLoading: false, };

      case GET_RECEIVE_INVENTORY:
         return { ...state, single: payload || initialState.single, isLoading: false };

      case UPDATE_RECEIVE_INVENTORY:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case ADD_RECEIVE_INVENTORY:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case DELETE_RECEIVE_INVENTORY:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case GET_LAST_RECEIVE_DAYBOOK:
         return {
            ...state,
            lastReceiveDaybook: payload,
         };

      case GET_RECEIVE_INVENTORY_PREV_AND_NEXT:
         return {
            ...state,
            prevAndNext: payload,
         };

      case EMPTY_ONE_RECEIVE_INVENTORY:
         return { ...state, single: initialState.single };

      case GET_PENDING_RECEIVE_INVENTORY:
         return {
            ...state,
            getPendingReceiveInventories: payload.data,
            isLoading: false,
         };
      case GET_SINGLE_RECEIVE_INVENTORIES:
         return {
            ...state,
            receiveData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
         };

      default:
         return state;
   }
};

export default reducer;
